import { login2factor } from "@/api/login/login-services";
import LangSelect from "@/components/lang-select";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import Loader from "@/components/utils/loader";
import { useStore } from "@/store";
import { zodResolver } from "@hookform/resolvers/zod";
import {useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { z } from "zod";

const formSchema = z.object({
  verifyCode: z.string().min(1, { message: "Code is required" }),
});

const TwoFactorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");
  const loggedInEmailUser = useStore((state) => state.loggedInEmailUser);
  const setLoggedInUser = useStore((state) => state.setLoggedInUser);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const companyData = useStore((state) => state.companyData);
  useEffect(() => {
    if (companyData?.title) {
      document.title = `${companyData.title}`;
    } else {
      document.title = "Canal Ético";
    }
  }, [companyData?.name]);

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      verifyCode: "",
    },
  });

  const onSubmit = async (data) => {
    setIsSubmitting((prev) => !prev);
    try {
      const twofactorResponse = await login2factor(
        loggedInEmailUser,
        data.verifyCode,
      );
      const token = localStorage.getItem("token");
      if (token) {
        setLoggedInUser(twofactorResponse.user);
        navigate("/admin/complaints");
      } else {
        throw new Error("Error en el login");
      }
    } catch (error) {
      toast.error(t("alertDialog.toast.2factorError"));
      setTimeout(() => {
        navigate("/login");
      }, 1500);
      console.error("Error de inicio de sesión:", error);
      setIsSubmitting(false);
      setLoginError(
        "Error en el inicio de sesión. Por favor, verifica tus credenciales.",
      );
    }
  };

  return (
    <section className="grid grid-cols-12 gap-4 w-full min-h-screen items-center">
      <div className="col-start-2 col-span-10 lg:col-start-5 lg:col-span-4 bg-slate-50 p-4">
        <Toaster />
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="col-start-1 col-span-12 h-auto flex justify-end">
              <LangSelect />
            </div>
            <h2 className="text-2xl mb-6 text-center font-bold">
              {t("twoFactorForm.title")}
            </h2>
            <h4 className="text-l mb-4 text-center">
              {t("twoFactorForm.subtitle")}
            </h4>

            <FormField
              control={form.control}
              name="verifyCode"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{t("twoFactorForm.code")}</FormLabel>
                  <FormControl>
                    <Input
                      placeholder={t("twoFactorForm.codePlaceholder")}
                      {...field}
                      type="text"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            {loginError && (
              <p className="text-red-500 text-sm mt-2">{loginError}</p>
            )}
            <div className="flex justify-center">
              <button
                disabled={isSubmitting}
                className="bg-primary hover:bg-primary-600 text-white font-bold py-2 px-4 mt-2 rounded focus:outline-none focus:shadow-outline w-1/2"
                type="submit"
              >
                {isSubmitting ? (
                  <Loader style={"buttonLoader"} />
                ) : (
                  t("twoFactorForm.buttonSend")
                )}
              </button>
            </div>
          </form>
        </Form>
      </div>
    </section>
  );
};

export default TwoFactorPage;
